import useViewport from 'components/general/useViewPort';
import React from 'react';

export const ResultRank = React.memo(({ result, rank, isUnchecked,rankEqual }) => {
  return (
    <div className='resultRank-result-rank'>
      <div className='resultRank-result'>{isUnchecked ? `(${result})` : result}</div>
      <div className={`${rank ? 'resultRank-rank' : 'resultRank-rank-empty'}`}>{rankEqual === 'Y' && rankEqual!==undefined ? '=':''}{rank}</div>
    </div>
  )
});

export const ResultRankDiff = React.memo(({ result, rank, diff, extensions, rankEqual }) => {
  const recordCode = extensions?.find(ext => ext?.ere_pos === '1' && ext?.ere_code === 'SPLIT_RECORD')?.ere_value
  const recordEqualled = extensions?.find(ext => ext?.ere_pos === '1' && ext?.ere_code === 'SPLIT_RECORD_EQ')?.ere_value === 'Y' && '='
  const record = recordCode && <span className='fw-bold'>{recordEqualled}{recordCode}</span>

  return (
    <>
      <div className='resultRank-result-rank'>
        <div className='resultRank-result'>{result}</div>
        <div className={`${rank ? 'resultRank-rank' : ''}`}><>{rankEqual === "Y" ? "=" : ""}{rank}</> <>{record}</></div>
      </div>
      <div>
        <div className='resultRank-result'>{diff}</div>
      </div>
    </>
  )
});

export const ResultDiff = React.memo(({ result, diff }) => {
  return (
    <>
      <div className='resultRank-result-rank'>
        <div className='resultRank-result-diff'>{result} </div>
      </div>
      <div>
        <div className='resultRank-result-diff'>{diff}</div>
      </div>
    </>
  )
});

export const DiffRank = React.memo(({ rank, diff }) => {
  return (
    <>
      <div className='resultRank-result-rank'>
        <div className='resultRank-result'>{diff}</div>
        <div className={`${rank ? 'resultRank-rank' : ''}`}>{rank}</div>
      </div>
    </>
  )
});

export const ResultRankDiffOws = React.memo(({ card, result, rank, diff }) => {
  return (
    <>
      <div className='resultRank-result-rank'>
        <div className='resultRank-result'>{card}&nbsp;{result}</div>
        <div className={`${rank ? 'resultRank-rank' : ''}`}>{rank}</div>
      </div>
      <div>
        <div className='resultRank-result'>{diff}</div>
      </div>
    </>
  )
});

export const ResultCompetitor = React.memo(({ bib, noc, competitor }) => {
  const { breakPoint } = useViewport();
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  return (
    <>
      {isMobile
        ? <>
          <div className='d-flex flex-row'>
            <div className='my-auto me-1 resultRacefacts-bib text-end' >{bib}</div>
            <div className='my-auto'>{noc}</div>
          </div>
          <div className=''>{competitor}</div>
        </>
        : <div className='d-flex flex-row'>
          <div className='my-auto me-1 resultRacefacts-bib text-end' >{bib}</div>
          <div className='my-auto'>{noc}</div>
          <div className=''>{competitor}</div>
        </div>
      }
    </>
  )
});

export default ResultRank